'use client'
import { usePathname } from 'next/navigation'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { NotificationBanner, NotificationTypes } from '@dustin-web/microsite-components/src/banners'
import { GET_NOTIFICATION_BANNER_RESULT } from '@dustin-web/microsite-data/src/graphql/content/get-notification-banner.graphql'
import { GetNotificationBannerResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'
import isPublicConvertedDate from '../utils'
import { cleanB2CRedirectTitle, isB2CBanner, isBannerAllowed } from './b2c-redirect-util'
import { isPathMatch } from '../utils/path-match'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'

const NotificationBannerContainer = () => {
  const pageUri = usePathname()
  const { cookies } = useCookieState()
  const { enabled: isB2CRedirectEnabled } = useFeatureFlag(
    'enable-b2c-decommission-notification-banner'
  )

  const { data } = useGraphql<GetNotificationBannerResultQuery>(GET_NOTIFICATION_BANNER_RESULT)
  const { notificationbanner } = data ?? {}

  if (!notificationbanner) {
    return
  }

  const {
    notificationDisplayEverywhere,
    notificationDisplayUrls,
    notificationPublished,
    notificationUnpublished,
    notificationButtonText,
    notificationButtonUrl,
    notificationType,
    notificationTitle,
    notificationDescription,
    notificationContentList,
    notificationPrimaryButton,
  } = notificationbanner

  if (
    (!notificationDisplayEverywhere && !isPathMatch(notificationDisplayUrls, pageUri)) ||
    !isPublicConvertedDate(notificationPublished || '', notificationUnpublished || '')
  ) {
    return
  }

  const isB2CNotifictionBanner = isB2CBanner(notificationTitle)
  const isNotificaitonBannerAllowed = isBannerAllowed(
    isB2CRedirectEnabled,
    notificationTitle,
    cookies.b2cRedirect
  )

  if (!isNotificaitonBannerAllowed) {
    return
  }

  const ctaButtonEnabled = notificationButtonText && notificationButtonUrl

  return (
    <NotificationBanner
      customIcon={notificationType === NotificationTypes.WARNING ? 'sad-dislike-face' : undefined}
      type={(notificationType as `${NotificationTypes}`) || NotificationTypes.INFO}
      closeable={!isB2CRedirectEnabled && !isB2CBanner}
      fullWidth
      title={
        isB2CRedirectEnabled && isB2CNotifictionBanner
          ? cleanB2CRedirectTitle(notificationTitle)
          : notificationTitle
      }
      description={notificationDescription}
      list={notificationContentList}
      ctaButton={!!ctaButtonEnabled}
      href={notificationButtonUrl}
      buttonText={notificationButtonText}
      primaryButton={notificationPrimaryButton}
    />
  )
}

export default NotificationBannerContainer
